import { MultipleViewerManager, SingleViewerManager as PopupManager } from '../ViewerPopupManager';

import axios from 'axios';
import repository from '../data/viewer';

let listener = null;

const getKeyForStudies = (studies, readOnly, options) => {
  if (studies.length) return repository.getIndexKey(studies, readOnly, options);
};

const getViewerManager = (allowMultiple, key) =>
  allowMultiple ? MultipleViewerManager.getPopupManager(key) : PopupManager;

export const DicomViewer = {
  namespaced: true,

  state: {
    managers: {},
    viewerOpen: false,
    currentOpenViewer: null,
    viewerTokens: {},
    viewerUrls: {},
    viewerEventsUrl: {},
    currentViewerIsReadOnly: false,
    allowMultiple: false,
    buttonExternallyTriggered: false,
  },

  actions: {
    allowMultipleViewers({ commit }) {
      commit('setMultipleViewersEnabled', true);
    },

    denyMultipleViewers({ commit }) {
      commit('setMultipleViewersEnabled', false);
    },

    openViewer({ commit, state, rootGetters }, { studies, keyImages, options = {}, appSection }) {
      const { project } = rootGetters;
      const configurationInProject = project && ![undefined, null].includes(project.enableMultipleViewerWindows);
      const enableMultipleViewerWindows = configurationInProject
        ? project.enableMultipleViewerWindows
        : state.allowMultiple;
      const key = getKeyForStudies(studies, options.readOnly, options);
      const url = state.viewerUrls[key];
      const viewerUrl = state.viewerEventsUrl[key];

      const manager = getViewerManager(enableMultipleViewerWindows, key);

      if (url && window) {
        manager.openWindow(url, studies, state.viewerTokens[key], options, keyImages, appSection);

        //commit('setOpenWindow', openWindow);
        commit('setViewerOpen', true);
      }
      if (viewerUrl) {
        axios.put(viewerUrl).catch((err) => console.error(err));
      }
    },

    closeViewer({ commit, state, dispatch }, studies, options = {}) {
      const key = getKeyForStudies(studies, options.readOnly, options);
      const manager = getViewerManager(state.allowMultiple, key);

      dispatch('isViewerOpen', { studies, options }).then((viewerOpen) => {
        if (viewerOpen) {
          manager.closeStudies(studies, state.viewerTokens[key], options);

          if (!options.keepOpen) {
            manager.closeWindow();

            window?.removeEventListener('message', listener);

            commit('setOpenWindow', null);
            commit('setViewerOpen', false);
          }
        }
      });
    },

    isViewerOpen({ commit, state }, studies, options = {}) {
      const key = getKeyForStudies(studies, options.readOnly, options);
      const manager = getViewerManager(state.allowMultiple, key);
      const open = manager.isPopupOpen();
      commit('setViewerOpen', open);
      return open ?? false;
    },

    unregisterButton({ state }, { studies, options = {} }) {
      const key = getKeyForStudies(studies, options.readOnly, options);
      const manager = getViewerManager(state.allowMultiple, key);

      if (manager.isOpen) {
        manager.closeStudies(studies, state.viewerTokens[key], options);
      }

      repository.unregisterStudies(studies, options.readOnly, options);
    },

    async registerButton(_ctx, { studies, options = {}, caseId = null }) {
      await repository.registerStudies(
        studies,
        options.readOnly,
        caseId,
        options.segmentation,
        options.segmentationUids,
        options
      );
    },

    initialize(ctx) {
      repository.registerStore(ctx);
    },

    updateButtonExternallyTriggered({ commit }, boolean) {
      commit('setButtonExternallyTriggered', boolean);
    },
  },

  getters: {
    getTokenForStudies: (state) => (studies, options) => {
      const key = getKeyForStudies(studies, options.readOnly, options);

      return state.viewerTokens[key] || null;
    },

    getUrlForStudies: (state) => (studies, options) => {
      const key = getKeyForStudies(studies, options.readOnly, options);

      return state.viewerUrls[key] || null;
    },

    isTokenLoadedForStudies:
      ({ viewerTokens }) =>
      (studies, options) => {
        const key = getKeyForStudies(studies, options.readOnly, options);

        return !Object.keys(viewerTokens).includes(key);
      },

    getButtonExternallyTriggered: (state) => () => {
      return state.buttonExternallyTriggered;
    },
  },

  mutations: {
    updateTokens(state, newTokens) {
      state.viewerTokens = { ...newTokens };
    },

    setMultipleViewersEnabled(state, enabled) {
      state.allowMultiple = enabled;
    },

    updateUrls(state, newUrls) {
      state.viewerUrls = { ...newUrls };
    },

    updateViewerEventUrl(state, newUrls) {
      state.viewerEventsUrl = newUrls;
    },

    setOpenWindow(state, windowRef) {
      state.currentOpenViewer = windowRef;
    },

    setViewerOpen(state, newState = false) {
      state.viewerOpen = newState;
    },

    setButtonExternallyTriggered(state, click) {
      state.buttonExternallyTriggered = click;
    },
  },
};
